export const delay = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

// A style change applied in this tick (e.g. via setState) isn't painted until
// the *next* frame, so a CSS transition's clock doesn't start until then either.
// Waiting two rAFs (one for the frame to be scheduled, one for it to have been
// painted) before counting down the transition duration keeps a JS timer in
// sync with the CSS transition it's meant to wait out.
export const waitForNextPaint = () =>
  new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
